import { getTtsPollyAudioBlob } from '@/src/services';
import { audioManager } from '@/src/lib';
import { extractXmlText } from '@/src/utils';

export async function handleTTS(
    text: string,
    setError?: (err: string) => void,
    callback?: (e: any) => void
) {
    // Format for neat reading -- includes xml extraction and replacing things like '-' with 'minus'
    text = extractXmlText(text).join('. ');

    if (!text.trim()) return;

    try {
        if (setError) {
            setError('');
        }
        const audioBlob = await getTtsPollyAudioBlob(text);

        await audioManager.playBlob(audioBlob, callback);
    } catch {
        if (setError) {
            setError('Failed to play audio.');
        }
    }
}
